<template>
  <div class="container">
    <FileUpload v-for="(prop, index) in props" v-bind="prop" :key="index" />
  </div>
</template>

<script>
import Constants from '../../constants/constants';
import FileUpload from '../shared/FileUpload.vue';

export default {
  name: 'GroupFileUpload',
  data() {
    return {
      props: [
        {
          api: Constants.Api.Endpoint.CoolantFileUpload.sample,
          fileTypeName: Constants.CoolantFileUpload.FileNameType.sample
        },
        {
          api: Constants.Api.Endpoint.CoolantFileUpload.ic,
          fileTypeName: Constants.CoolantFileUpload.FileNameType.ic
        },
        {
          api: Constants.Api.Endpoint.CoolantFileUpload.icp,
          fileTypeName: Constants.CoolantFileUpload.FileNameType.icp
        },
        {
          api: Constants.Api.Endpoint.OilFileUpload.icp,
          fileTypeName: Constants.OilFileUpload.FileNameType.icp
        },
        {
          api: Constants.Api.Endpoint.OilFileUpload.ir,
          fileTypeName: Constants.OilFileUpload.FileNameType.ir
        },
        {
          api: Constants.Api.Endpoint.OilFileUpload.oe4,
          fileTypeName: Constants.OilFileUpload.FileNameType.oe4
        },
        {
          api: Constants.Api.Endpoint.OilFileUpload.viscosity,
          fileTypeName: Constants.OilFileUpload.FileNameType.viscosity
        },
        {
          api: Constants.Api.Endpoint.OilFileUpload.particleCount,
          fileTypeName: Constants.OilFileUpload.FileNameType.particleCount
        }
      ]
    };
  },
  components: {
    FileUpload
  }
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-wrap: wrap;

  .file-upload {
    flex: 0 0 50%;
  }
}
</style>
